<template>
  <v-row align="center" justify="center">
    <v-card max-width="75%" width="500" flat color="background">
        <!-- Agendar -->
      <v-row align="center" justify="center">
        <v-col cols="4">
          <v-row align="center" justify="center" class="mb-3">
            <v-card width="200" height="120" elevation="0" class="rounded">
              <v-container fluid>
                <v-row align="center" justify="center">
                  <img src="../assets/agendado.svg" width="100px" class="ml-2" />
                </v-row>
              </v-container>
            </v-card>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row align="center" justify="center" class="ml-2">
              <v-row align="center" justify="center">
              <h1>Agenda 24 / 7</h1>
          </v-row>
          <v-row align="center" justify="center" class="ml-2 mt-1">
              <p>Elige un día y un horario disponible, sin llamadas ni personas, desde tu celular.</p>
          </v-row>
          </v-row>
        </v-col>
      </v-row>
      <!-- Tiempo Real -->
      <v-row align="center" justify="center">
        <v-col cols="4">
          <v-row align="center" justify="center" class="mb-3">
            <v-card width="200" height="120" elevation="0" class="rounded">
              <v-container fluid>
                <v-row align="center" justify="center">
                  <img src="../assets/tiempoReal.svg" width="100px" class="ml-2" />
                </v-row>
              </v-container>
            </v-card>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row align="center" justify="center" class="ml-2">
              <v-row align="center" justify="center">
              <h1>Tiempo real</h1>
          </v-row>
          <v-row align="center" justify="center" class="ml-2 mt-1">
              <p>Sigue en el mapa la ruta de tu repartidor y recibe actualizaciones en la app.</p>
          </v-row>
          </v-row>
        </v-col>
      </v-row>
       <!-- Pago en linea -->
      <v-row align="center" justify="center">
        <v-col cols="4">
          <v-row align="center" justify="center" class="mb-3">
            <v-card width="200" height="120" elevation="0" class="rounded">
              <v-container fluid>
                <v-row align="center" justify="center">
                  <img src="../assets/pagoLinea.svg" width="100px" class="ml-2" />
                </v-row>
              </v-container>
            </v-card>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row align="center" justify="center" class="ml-2">
              <v-row align="center" justify="center">
              <h1>Pago en línea</h1>
          </v-row>
          <v-row align="center" justify="center" class="ml-2 mt-1">
              <p>100% seguro, aceptamos todas las tarjetas visa y mastercard.</p>
          </v-row>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
export default {};
</script>

<style scoped>
.rounded {
  border-radius: 8px !important;
  box-shadow: 0 -2px 15px 0 rgba(116, 146, 174, 0.17)!important
}
</style>